<template>
  <v-dialog v-model="dialog" max-width="400px" persistent>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Modifica Termostato
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field label="Nome" v-model="nome" outlined></v-text-field>
          </v-col>
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-6" justify="center">
          <v-col cols="12" v-if="!therm.isExternal">
            <v-slider
              v-model="gal_h"
              :max="5"
              :min="0"
              step="0.1"
              label="gal/h"
              thumb-label="always"
              class="mt-4"
              color="teal"
              :track-color="'teal lighten-3'"
              outlined
              hide-details
            ></v-slider>
          </v-col>

          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1"
            >Litri/ora: {{ (gal_h * 3.78541).toFixed(1) }} L/h</v-col
          >
        </v-row>
        <v-divider v-if="!therm.isExternal" class="my-4" />
        <v-row no-gutters>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1 my-4"
            ><v-icon class="mr-4" @click="position--">mdi-minus</v-icon>
            Posizione: {{ position + 1 }}
            <v-icon class="ml-4" @click="position++">mdi-plus</v-icon>
          </v-col>
        </v-row>
        <v-divider v-if="!therm.isExternal" class="my-4"></v-divider>
        <v-row no-gutters>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1 mt-4"
          >
            <v-switch
              v-model="phoneEnabled"
              inset
              label="Allarme Telefonico"
            ></v-switch>
          </v-col>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1"
          >
            <v-switch
              v-model="pushEnabled"
              inset
              label="Notifiche Push"
            ></v-switch>
          </v-col>
        </v-row>
        <v-divider class="my-4" v-if="!therm.isExternal"></v-divider>
        <v-card outlined>
          <v-card-title class="grey--text font-weight-light">
            Danger Zone
          </v-card-title>
          <v-card-text>
            <v-row no-gutters class="mt-n4">
              <v-col class="">
                <v-dialog v-model="dialogDeleteRecords" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      outlined
                      block
                      class="mt-4"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Elimina Records Termostato
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="red--text text-subtitle-1">
                      Conferma Eliminazione
                    </v-card-title>
                    <v-card-text>
                      Sei sicuro di voler eliminare i records del termostato
                      <strong>{{ therm.nome }}</strong
                      >? Questa azione non è reversibile!

                      <v-select
                        class="mt-4"
                        v-model="deleteOption"
                        :items="[
                          {
                            text: 'Elimina solo i records più vecchi di 3 giorni',
                            value: 3,
                          },
                          {
                            text: 'Elimina solo i records più vecchi di 7 giorni',
                            value: 7,
                          },
                          {
                            text: 'Elimina solo i records più vecchi di 30 giorni',
                            value: 30,
                          },
                          {
                            text: 'Elimina solo i records più vecchi di 180 giorni',
                            value: 180,
                          },
                          {
                            text: 'Elimina solo i records più vecchi di 1 anno',
                            value: 365,
                          },
                          { text: 'Elimina tutti i records', value: 0 },
                        ]"
                        label="Scegli un'opzione"
                        item-text="text"
                        item-value="value"
                        outlined
                      ></v-select>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        text
                        color="grey"
                        @click="dialogDeleteRecords = false"
                        >Annulla</v-btn
                      >
                      <v-btn color="red" outlined @click="eliminaRecords"
                        >Elimina</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col class="">
                <v-dialog v-model="dialogDeleteTherm" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      outlined
                      block
                      class="mt-4"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Elimina Termostato
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="red--text text-subtitle-1">
                      Conferma Eliminazione
                    </v-card-title>
                    <v-card-text>
                      Sei sicuro di voler eliminare il termostato
                      <strong>{{ therm.nome }}</strong
                      >? Questa azione non è reversibile e verranno eliminati
                      tutti i records ad esso collegati!
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        text
                        color="grey"
                        @click="dialogDeleteTherm = false"
                        >Annulla</v-btn
                      >
                      <v-btn color="red" outlined @click="eliminaThermostat"
                        >Elimina</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="mt-8">
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
        <v-btn outlined color="green" @click="save()">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import moment from "moment";
import therm_edit_mixin from "../mixin/therm_edit_mixin";
export default {
  name: "ThermEditBox",
  mixins: [therm_edit_mixin],
  // props: {
  //   therm: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  // data() {
  //   return {
  //     dialog: false,
  //     gal_h: null,
  //     nome: null,
  //     position: null,
  //     phoneEnabled: false,
  //     pushEnabled: false,
  //     dialogDeleteRecords: false,
  //     dialogDeleteTherm: false,
  //     deleteOption: 30,
  //   };
  // },
  // watch: {
  //   position(newVal) {
  //     if (newVal < 0) this.position = 0;
  //     if (newVal > this.$store.getters.get_therm.length - 1)
  //       this.position = this.$store.getters.get_therm.length - 1;
  //   },
  // },
  // methods: {
  //   open() {
  //     this.dialog = true;
  //     this.gal_h = this.therm.lit_h || 0;
  //     this.nome = this.therm.nome || "";
  //     this.position = this.therm.position || 0;
  //     this.phoneEnabled = this.therm.phoneEnabled || false;
  //     this.pushEnabled = this.therm.pushEnabled || false;
  //   },
  //   save() {
  //     this.changeThermSettings();
  //     this.dialog = false;
  //   },
  //   changePosition() {
  //     this.$store.dispatch("changeThermPosition", {
  //       sid: this.therm.sid,
  //       newPos: this.therm.position,
  //     });
  //   },
  //   changeThermSettings() {
  //     this.$store.dispatch("changeThermSettings", {
  //       sid: this.therm.sid,
  //       settings: {
  //         lit_h: this.gal_h,
  //         nome: this.nome,
  //         position: this.position,
  //         phoneEnabled: this.phoneEnabled,
  //         pushEnabled: this.pushEnabled,
  //       },
  //     });
  //   },
  //   eliminaRecords() {
  //     this.$store.dispatch("deleteThermRecords", {
  //       sid: this.therm.sid,
  //       ts_fine: moment()
  //         .subtract(this.deleteOption, "days")
  //         .endOf("day")
  //         .unix(),
  //     });
  //     this.dialogDeleteRecords = false;
  //   },
  //   eliminaThermostat() {
  //     this.$store.dispatch("deleteThermostat", {
  //       sid: this.therm.sid,
  //     });
  //     this.dialogDeleteTherm = false;
  //     this.dialog = false;
  //   },
  // },
};
</script>